$(function() {
  $('.form-group--password').on('click', '[type="button"]', function(e) {
    var $el = $(this),
      $input = $el.siblings('input'),
      inputType = $input.attr('type'),
      $parent = $(e.delegateTarget)

    if (inputType == 'password') {
      $input.attr('type', 'text')
      $parent.addClass('form-group--password-active')
    } else {
      $input.attr('type', 'password')
      $parent.removeClass('form-group--password-active')
    }
  })
})
